import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-734b8782"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-eer-overview" }
const _hoisted_2 = { class: "shade mt-4 mb-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Law Practice Name:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Trading Name:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Branch Address:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Relevant Period:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " The procedures to be adopted by the external examiner to complete this report are to be sufficient to enable the external examiner to form an opinion in accordance with the Uniform Law and Uniform General Rules regulating the maintenance of trust records and the receipting and disbursement of trust money by the Law Practice. ", -1))
const _hoisted_8 = { class: "file-area mt-4" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Uploaded files", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "ml-2" }, "General Trust Money Bank Reconciliation:", -1))
const _hoisted_12 = { class: "file ml-2" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = { class: "file-name" }
const _hoisted_16 = { class: "col-6" }
const _hoisted_17 = { class: "file-date" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "ml-2" }, "General Trust Money Overdrawn Ledger:", -1))
const _hoisted_21 = { class: "file ml-2" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-6" }
const _hoisted_24 = { class: "file-name" }
const _hoisted_25 = { class: "col-6" }
const _hoisted_26 = { class: "file-date" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "ml-2" }, "Controlled Money:", -1))
const _hoisted_30 = { class: "file ml-2" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-6" }
const _hoisted_33 = { class: "file-name" }
const _hoisted_34 = { class: "col-6" }
const _hoisted_35 = { class: "file-date" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "ml-2" }, "Investment Money:", -1))
const _hoisted_39 = { class: "file ml-2" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-6" }
const _hoisted_42 = { class: "file-name" }
const _hoisted_43 = { class: "col-6" }
const _hoisted_44 = { class: "file-date" }
const _hoisted_45 = ["onClick"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (!_ctx.loadingContent && !_ctx.errorLoadingContent)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", null, _toDisplayString(_ctx.overviewContent?.firmName) + " / " + _toDisplayString(_ctx.overviewContent?.firmId), 1),
            _hoisted_4,
            _createElementVNode("div", null, _toDisplayString(_ctx.overviewContent?.tradingName  || ' - '), 1),
            _hoisted_5,
            _createElementVNode("div", null, _toDisplayString(_ctx.overviewContent?.branchAddress), 1),
            _hoisted_6,
            _createElementVNode("div", null, _toDisplayString(_ctx.$formatDateFullDate(_ctx.overviewContent?.complianceYearStart)) + " - " + _toDisplayString(_ctx.$formatDateFullDate(_ctx.overviewContent?.complianceYearEnd)), 1)
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _hoisted_10,
            _createElementVNode("div", null, [
              _hoisted_11,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.overviewContent?.generalTrustMoneyBankReconciliationFiles, (f, i) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, _toDisplayString(f?.fileName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("button", {
                          class: "btn btn-secondary sml",
                          onClick: $event => (_ctx.downloadFile(f))
                        }, "Download", 8, _hoisted_18)
                      ])
                    ])
                  ])
                ]))
              }), 256)),
              _hoisted_19,
              _hoisted_20,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.overviewContent?.generalTrustMoneyOverdrawnLedgerFiles, (f, i) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, _toDisplayString(f?.fileName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("button", {
                          class: "btn btn-secondary sml",
                          onClick: $event => (_ctx.downloadFile(f))
                        }, "Download", 8, _hoisted_27)
                      ])
                    ])
                  ])
                ]))
              }), 256)),
              _hoisted_28,
              _hoisted_29,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.overviewContent?.controlledMoneyFiles, (f, i) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, _toDisplayString(f?.fileName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("button", {
                          class: "btn btn-secondary sml",
                          onClick: $event => (_ctx.downloadFile(f))
                        }, "Download", 8, _hoisted_36)
                      ])
                    ])
                  ])
                ]))
              }), 256)),
              _hoisted_37,
              _hoisted_38,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.overviewContent?.investmentMoneyFiles, (f, i) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, _toDisplayString(f?.fileName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("button", {
                          class: "btn btn-secondary sml",
                          onClick: $event => (_ctx.downloadFile(f))
                        }, "Download", 8, _hoisted_45)
                      ])
                    ])
                  ])
                ]))
              }), 256))
            ])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}